import { IEmailPreferences, IPhotoPreferences, IFeaturePreferences, IUserPreferences } from "../types/userpreferences";
import { graphResponse } from "./network";

const userPreferencesApi = "{{vroomOrigin}}/{{apiVersion2}}/drive/userPreferences";
const userPreferencesApiPhoto = "{{vroomOrigin}}/{{apiVersion2}}/drive/userPreferences/photo";
const userPreferencesApiEmail = "{{vroomOrigin}}/{{apiVersion2}}/drive/userPreferences/email";
const userPreferencesApiFeature = "{{vroomOrigin}}/{{apiVersion2}}/drive/userPreferences/featureSettings";

/**
 * Get the user's preferences
 *
 * @param fetch
 * @returns The user's preferences
 */
export function getUserPreferences(fetch: (url: string, init?: RequestInit) => Promise<Response>): Promise<IUserPreferences> {
  return graphResponse(fetch(userPreferencesApi));
}

/**
 * Update the user's photos preferences
 *
 * @param fetch
 * @param preferences
 * @returns The updated photo preferences
 */
export function updatePhotoPreferences(
  fetch: (url: string, init?: RequestInit) => Promise<Response>,
  preferences: Partial<IPhotoPreferences>
): Promise<IPhotoPreferences> {
  return graphResponse(
    fetch(userPreferencesApiPhoto, {
      body: JSON.stringify(preferences),
      headers: { "content-type": "application/json" },
      method: "PATCH"
    })
  );
}

/**
 * Update the user's email preferences
 *
 * @param fetch
 * @param preferences
 * @returns The updated email preferences
 */
export function updateEmailPreferences(
  fetch: (url: string, init?: RequestInit) => Promise<Response>,
  preferences: Partial<IEmailPreferences>
): Promise<IEmailPreferences> {
  return graphResponse(
    fetch(userPreferencesApiEmail, {
      body: JSON.stringify(preferences),
      headers: { "content-type": "application/json" },
      method: "PATCH"
    })
  );
}

/**
 * Update the user's feature preferences
 *
 * @param fetch
 * @param preferences
 * @returns The updated feature preferences
 */
export function updateFeaturePreferences(
  fetch: (url: string, init?: RequestInit) => Promise<Response>,
  preferences: Partial<IFeaturePreferences>
): Promise<IFeaturePreferences> {
  return graphResponse(
    fetch(userPreferencesApiFeature, {
      body: JSON.stringify(preferences),
      headers: { "content-type": "application/json" },
      method: "PATCH"
    })
  );
}
